module.exports = flarum.core.compat['components/EditPostComposer'];